import { capitalize } from 'inflection';
import { Boolean, Keyword, Number } from '../../values/index.js';
export var WordBreak;
(function (WordBreak) {
    WordBreak["normal"] = "normal";
    WordBreak["break-word"] = "break-word";
    WordBreak["break-all"] = "break-all";
    WordBreak["hyphens"] = "hyphens";
})(WordBreak || (WordBreak = {}));
export var TextAlign;
(function (TextAlign) {
    TextAlign["left"] = "left";
    TextAlign["center"] = "center";
    TextAlign["right"] = "right";
    TextAlign["justify"] = "justify";
})(TextAlign || (TextAlign = {}));
export const Props = (props = {}) => {
    var _a;
    return ({
        textAlign: Keyword(props.textAlign, TextAlign),
        lines: Number(props.lines),
        ellipsis: (_a = Boolean(props.ellipsis)) !== null && _a !== void 0 ? _a : Number(props.lines) === 1,
        wordBreak: Keyword(props.wordBreak, WordBreak, WordBreak['normal'])
    });
};
export const validate = () => true;
export const fix = (props, styles) => props;
export const label = 'Text settings';
export const type = 'lines';
export const property = 'linesIds';
export const category = 'aspect';
export const summarize = (props, styles, formId) => {
    const rulesToDisplay = [];
    if (props.textAlign !== 'left')
        rulesToDisplay.push(capitalize(props.textAlign));
    if (props.lines === 1)
        rulesToDisplay.push(props.ellipsis ? 'Ellipsis' : 'Display');
    if (props.lines > 1)
        rulesToDisplay.push(`max ${props.lines} lines`);
    return rulesToDisplay.join(' / ');
};
//# sourceMappingURL=lines.js.map